export const votingGoalConstants = {
  VOTINGGOAL_REQUEST: 'VOTINGGOAL_REQUEST',
  VOTINGGOAL_SUCCESS: 'VOTINGGOAL_SUCCESS',
  VOTINGGOAL_FAILURE: 'VOTINGGOAL_FAILURE',

  VOTINGGOAL_SAVE_REQUEST: 'VOTINGGOAL_SAVE_REQUEST',
  VOTINGGOAL_SAVE_SUCCESS: 'VOTINGGOAL_SAVE_SUCCESS',
  VOTINGGOAL_SAVE_FAILURE: 'VOTINGGOAL_SAVE_FAILURE'
}
